import { useClassNames } from '@magnetic/hooks';
import { MagnifyingGlass } from '@magnetic/icons';
import { Input } from '@magnetic/input';
import React, { forwardRef } from 'react';

const Search = forwardRef(
  ({ className, ...props }, ref) => /* @__PURE__ */ React.createElement(Input.Autocomplete, {
    ...props,
    className: useClassNames("mds-search", className),
    hiddenLabel: true,
    prefix: /* @__PURE__ */ React.createElement(MagnifyingGlass, null),
    ref
  })
);

export { Search };
//# sourceMappingURL=index.js.map
